// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"580bdc70","455":"afadc1d2"}[chunkId] + ".chunk.js";
};